import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_FollowUpDocumentation = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_FollowUpDocumentation' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>
                    <center><h2>FOLLOW-UP <br />
                        DOCUMENTATION CONTINUED
                    </h2> </center>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>NAME:</span>

                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>MEDICAID NUMBER:</span>

                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName' name='txtName' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtMedicaidNumber' name='txtMedicaidNumber' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>CONTINUATION OF FOLLOW-UP NUMBER:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbOne' name='cbOne' className='add-only' value='One' /> ONE </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTwo' name='cbTwo' className='add-only' value='Two' /> TWO </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThree' name='cbThree' className='add-only' value='Three' /> THREE </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbFour' name='cbFour' className='add-only' value='Four' /> FOUR </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbFive' name='cbFive' className='add-only' value='Five' /> FIVE </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSix' name='cbSix' className='add-only' value='Six' /> SIX </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSeven' name='cbSeven' className='add-only' value='Seven' /> SEVEN </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbEight' name='cbEight' className='add-only' value='Eight' /> EIGHT </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNine' name='cbNine' className='add-only' value='Nine' /> NINE </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTen' name='cbTen' className='add-only' value='Ten' /> #&nbsp;
                            <input type='text' id='txtTenAdditionalInfo' name='txtTenAdditionalInfo' className='add-only w-50 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>SUMMARY OF FOLLOW-UP CONTACT CONTINUED</span>
                    <span className='small'>THIS IS A SUPPLEMENTAL PAGE AND MUST BE ATTACHED TO A COMPLETED CM-04 FOLLOW-UP FORM. <br />
                        THE CASE MANAGER MUST SIGN AND DATE THE CM-04</span>
                    <textarea id='txtSummaryOfFollowUp' name='txtSummaryOfFollowUp' className='add-only'></textarea>
                </p>
            </div>
        </form>

    )
}











